import { render, staticRenderFns } from "./JobDetailSimilar.vue?vue&type=template&id=68e5a3e9&"
import script from "./JobDetailSimilar.vue?vue&type=script&lang=js&"
export * from "./JobDetailSimilar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports